<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{config.i18n.wia_title}}</h2>
      <div class="wia-select wia-select--categories">
        <span class="wia-label">{{config.i18n.wia_need_help}} </span>
        <div class="wia-select__wrapper wia-select--dropdown">
          <select class="wia-select__item" @change="onChange()" v-model="categorySelected">
            <option v-for="option in categoriesOptions" v-bind:value="{ id: option.id, text: option.description }" v-bind:key="option.id">
              {{ option.description }}
            </option>
          </select>
          <svg id="accordion-arrow" viewBox="0 0 40 40" width="100%" height="100%"><path d="M39.2 9.7c-.4-.4-1-.7-1.6-.7-.8 0-1.4.5-1.6.6L20.4 25.2 4 8.8c-.1-.1-.7-.7-1.5-.7-.4 0-1 .1-1.6.7C-.3 10 .1 11.4.5 12v.1l.1.1 19.2 19.2.6.6.6-.6 18.2-18.1.1-.1v-.1c.5-.7 1.1-2.3-.1-3.4z"></path></svg>
        </div>
      </div>
      <div class="wia-select wia-select--categories wia-select--autocomplete">
        <span class="wia-label">{{config.i18n.wia_model_name}}</span>
        <div class="wia-select__wrapper">
          <v-wia-auto :items="commlist" ref="wiaComm" @input="onInputWIA" @select="onSelectWIA"></v-wia-auto>
        </div>
        <span class="wia-label wia-label--optional">{{config.i18n.wia_optional_label}}</span>
      </div>
      <div class="wia-container__btn">
        <button class="btn wia-form__button button btn btn-primary" v-on:click="onSubmit()">{{config.i18n.wia_confirm}}</button>
      </div>
      <!-- Exclude stores on VTEX without --all-categories pages -->
      <!-- OLD logic -> config.i18n.wia_all_solution.length > 0 && brand_country !== 'WP_IT' && brand_country !== 'WP_FR' && brand_country !== 'WP_PL' && brand_country !== 'HP_IT' && brand_country !== 'ID_FR' && brand_country !== 'ID_IT' && brand_country !== 'ID_PL' -->
      <div class="wia-container__btn" v-show="show_categories_link">
        <a :href="this.allLink">{{config.i18n.wia_all_solution}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Vue from 'vue'
import wiaAuto from '@/components/modules/WIAAutocomplete'
import {filterAllowedCategories} from '@/helpers/allowedCategoriesFilter'
import {getMetaBrand, getMetaCountry, getMetaStaticByTag} from '@/helpers/seoMetatagInfo'
Vue.component('v-wia-auto', wiaAuto)
/* import { LOGIN } from '@/const/const.type' */
export default {
  name: 'WIA-Home',
  title () {
    return `${this.getMetaStaticByTag('title')} | ${this.getMetaBrand()} ${this.getMetaCountry()}`
  },
  description () {
    var metaDescriptionHome = this.getMetaStaticByTag('description_home') ? this.getMetaStaticByTag('description_home') : this.getMetaStaticByTag('description')
    return metaDescriptionHome ? `${metaDescriptionHome}.` : `${this.getMetaStaticByTag('title')}.`
  },
  data () {
    return {
      categorySelected: null,
      categoriesOptions: [
      ],
      modelSelected: null,
      commcodeList: [],
      commlist: [],
      errormsg: null,
      searchText: null,
      allLink: null
    }
  },
  meta: {
    name: 'robots',
    content: 'index'
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    config: function () {
      return this.$store.state.config
    },
    detail: function () {
      return this.$store.state.details
    },
    brand_country: function () {
      return this.$store.state.config.brand + '_' + this.$store.state.config.country
    },
    show_categories_link: function () {
      // Manage here custom logic to show/hide the link of categories navigation
      return this.$store.state.config.i18n.wia_all_solution.length > 0
    }
  },
  methods: {
    onChange () {
      this.modelSelected = {'sku': null, 'code': null}
      var child = this.$refs.wiaComm
      child.setResult('', null)
    },
    onSubmit (evt) {
      if (this.categorySelected !== null) {
        var child = this.$refs.wiaComm
        if (this.modelSelected === null || this.modelSelected.code === null || child.getSearchText().length <= 0) {
          this.modelSelected = {'sku': null, 'code': null}
        }
        this.$store.commit('saveDeviceData', {'category': this.categorySelected, 'model': this.modelSelected})
        this.$router.push({
          name: 'WIAStep1',
          params: {
            category: this.categorySelected,
            model: this.modelSelected
          },
          query: {
            productLine: this.categorySelected.text,
            product: this.modelSelected.sku
          }
        })
        if (window.dataLayer) {
          // window.dataLayer.push({
          //   'event': 'WIAPageView',
          //   'eventAction': document.location.href
          // })
        } else {
          console.log(document.location.href)
        }
      }
    },
    getMetaBrand () {
      return getMetaBrand(this.$store.state.config.brand.toLowerCase())
    },
    getMetaCountry () {
      return getMetaCountry(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.i18n || {})
    },
    getMetaStaticByTag (tag) {
      return getMetaStaticByTag(tag, this.$store.state.config.brand.toLowerCase(), this.$store.state.config.i18n || {})
    },
    getcommData () {
      this.commlist = []
      for (var key in this.commcodeList) {
        var datatemp = {'value': this.commcodeList[key].id, 'text': this.commcodeList[key].model}
        this.commlist.push(datatemp)
        if (key === '1000') {
          break
        }
      }
    },
    onInputWIA (value) {
      var child = this.$refs.wiaComm
      child.startLoader()
      // /models_by_product_line/{q}/{productLine}
      this.$http.get(this.$store.state.config.endpoint + '/models_by_product_line/' + value + '/' + this.categorySelected.id).then(
        result => {
          this.commcodeList = result.body
          this.getcommData()
          child.stopLoader()
        }, error => {
          child.stopLoader()
          this.errormsg = error.body
        })
    },
    onSelectWIA (value) {
      var child = this.$refs.wiaComm
      this.modelSelected = {'sku': value, 'code': child.$data.search}
    },
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    },
    updateMetaTitleBasedOnBrandAndCountry () {
      if (this.$store.state.config.homeTitle) {
        document.title = this.$store.state.config.homeTitle
      }
    }
  },
  mounted () {
    this.updateMetaTitleBasedOnBrandAndCountry()
    this.allLink = document.location.pathname.replace(/\/$/, '') + '/--all-categories'
    if (document.location.pathname.includes('--')) {
      let page = document.location.pathname.split('--').pop()
      const productLine = this.getQueryStringValue('productLine')
      const product = this.getQueryStringValue('product')
      const macroCat = this.getQueryStringValue('macroCat')
      const cat = this.getQueryStringValue('cat')
      const problemID = this.getQueryStringValue('problemID')
      const problemName = this.getQueryStringValue('problemName')
      const categoryName = this.getQueryStringValue('name')
      const l1 = this.getQueryStringValue('l1')
      const l2 = this.getQueryStringValue('l2')
      switch (page) {
        case 'step1':
          this.$router.push({name: 'WIAStep1',
            query: {
              productLine: productLine,
              product: product
            }})
          break
        case 'step2':
          this.$router.push({name: 'WIAStep2',
            query: {
              productLine: productLine,
              product: product,
              macroCat: macroCat
            }})
          break
        case 'step3':
          this.$router.push({name: 'WIAStep3',
            query: {
              productLine: productLine,
              product: product,
              macroCat: macroCat,
              cat: cat
            }})
          break
        case 'result':
          this.$router.push({name: 'WIAResult',
            query: {
              productLine: productLine,
              product: product,
              macroCat: macroCat,
              cat: cat,
              problemID: problemID,
              problemName: problemName
            }})
          break
        case 'all-categories':
          this.$router.push({ name: 'WIA-Categories' })
          break
        case 'category-issue':
          this.$router.push({ name: 'WIA-SeoL1Issue',
            query: {
              name: categoryName,
              cat: cat
            }})
          break
        case 'l1-issue':
          this.$router.push({ name: 'WIA-SeoL2Issue',
            query: {
              name: categoryName,
              cat: cat,
              l1: l1
            }})
          break
        case 'issues':
          this.$router.push({ name: 'WIA-SeoL3Issue',
            query: {
              name: categoryName,
              cat: cat,
              l1: l1,
              l2: l2
            }})
          break
      }
    }
    // /product_line/{language}
    this.$http.get(this.$store.state.config.endpoint + '/product_line/' + this.$store.state.config.language.toLowerCase()).then(
      result => {
        this.categoriesOptions = filterAllowedCategories(
          result.body,
          this.$store.state.config.brand.toLowerCase(),
          this.$store.state.config.language.toLowerCase()
        )
      })
    if (this.$store.state.details.category !== null) {
      this.categorySelected = this.$store.state.details.category
    }
    if (this.$store.state.details.model != null) {
      this.modelSelected = this.$store.state.details.model
      var child = this.$refs.wiaComm
      child.setResult(this.modelSelected.code, this.modelSelected.sku)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../style/main.scss';

  .brand-theme-id{
    .wia-select{
      &__item{
        height: 45px;
        padding-right: 2rem;
        padding-left: 0.5rem;
        @media (min-width: $desktop) {
          height: initial;
        }
      }
    }
    #accordion-arrow{
      position: absolute;
      right: 0;
    }
  }

  .brand-theme-hp{
    .wia-label{
      padding-top: 5px;
    }
  }

  .brand-theme-bk{
    .wia-label{
      padding-top: 5px;
    }
  }

  .brand-theme-mb{
    .wia-select{
      &__item{
        height: 45px;
        padding-right: 2rem;
        padding-left: 0.5rem;
        @media (min-width: $desktop) {
          height: initial;
        }
      }
    }
    #accordion-arrow{
      position: absolute;
      right: 0;
    }
  }

  .brand-theme-wp{
    #accordion-arrow{
      display: none;
    }
    .wia-select--autocomplete .wia-label{
      padding-top: 10px;
    }
  }

</style>
